import Swiper from 'swiper/bundle';


const fiches = {
    init() {
        this.initConfirm();
        this.initSwiper();
    },
    initConfirm() {
        $(document).off("click.confirmAction").on("click.confirmAction", ".__confirm_action", function (e) {
            const message = $(this).data("confirm") || "Confirmer cette action ?";
            if (!confirm(message)) {
                e.preventDefault();
                return false;
            }
        });
    },
    initSwiper() {
        if ($(".__events").length > 0) {
            const swiper = new Swiper(".__events", {
                slidesPerView: 3,
                spaceBetween: 20,
                watchOverflow: false,
                breakpoints: {
                    0: {slidesPerView: 1},
                    640: {slidesPerView: 1.3},
                    768: {slidesPerView: 2},
                    992: {slidesPerView: 3}
                },
                navigation: {
                    nextEl: ".evt-next",
                    prevEl: ".evt-prev",
                },
            });
            setTimeout(() => swiper.update(), 500);
        }
        if ($(".__medias").length > 0) {
            console.log("medias found", $(".__medias").length);

            let swiper_medias = null;

            try {
                swiper_medias = new Swiper(".__medias", {
                    slidesPerView: 2.5,
                    spaceBetween: 40,
                    watchOverflow: false,
                    breakpoints: {
                        0: {
                            slidesPerView: 1.1,
                            spaceBetween: 10,
                        },
                        640: {
                            slidesPerView: 1.3,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2
                        },
                        992: {
                            slidesPerView: 2.5,
                            spaceBetween: 40,
                        }
                    },
                    navigation: {
                        nextEl: ".__nav_medias .evt-next",
                        prevEl: ".__nav_medias .evt-prev"
                    }
                });
                this.setupMediaGallery(swiper_medias);
                //console.log("swiper medias OK", swiper_medias);

            } catch (error) {
                console.error("Erreur init swiper medias", error);
            }
        }

        // if ($(".__medias").length > 0) {
        //     const swiper_medias = new Swiper(".__medias", {
        //         slidesPerView: 2.5,
        //         spaceBetween: 40,
        //         watchOverflow: false,
        //         breakpoints: {
        //             0: {slidesPerView: 1},
        //             640: {slidesPerView: 1.3},
        //             768: {slidesPerView: 2},
        //             992: {slidesPerView: 2.5}
        //         },
        //         navigation: {
        //             nextEl: ".evt-next",
        //             prevEl: ".evt-prev"
        //         }
        //     });
        //     console.log("test");
        //     console.log(swiper_medias);
        //     //this.setupMediaGallery(swiper_medias);
        //     //this.setupMediaVideos(swiper_medias);
        //     //this.setupMediaImages(swiper_medias);
        // }
        swiper.on('slideChangeTransitionStart', () => {
            const iframes = container.querySelectorAll('iframe[src*="youtube.com/embed/"]');
            iframes.forEach(ifr => {
                try {
                    ifr.contentWindow.postMessage(
                        JSON.stringify({event: 'command', func: 'pauseVideo', args: []}),
                        '*'
                    );
                } catch (e) {
                }
            });
        });
    },

    setupMediaGallery(swiper) {
        const container = swiper.el;
        const modalEl = document.querySelector('.__modal_gallery');
        if (!modalEl) return;

        const box = modalEl.querySelector('.__gallery_container');
        const btnClose = modalEl.querySelector('.__close_modal');
        const btnPrev = modalEl.querySelector('.__gallery_prev');
        const btnNext = modalEl.querySelector('.__gallery_next');

        let medias = [];
        let currentIndex = 0;

        const refreshMedias = () => {
            medias = Array.from(container.querySelectorAll('._open_gallery')).map((item) => {
                const type = item.dataset.type;

                if (type === 'IMG') {
                    const img = item.querySelector('img');
                    return {
                        type: 'IMG',
                        src: item.dataset.full || img?.currentSrc || img?.src,
                        alt: img?.alt || ''
                    };
                }

                return {
                    type: 'VID',
                    ytid: item.dataset.ytid
                };
            }).filter(item => item.src || item.ytid);
        };

        const render = () => {
            const media = medias[currentIndex];
            if (!media) return;

            box.innerHTML = '';

            if (media.type === 'IMG') {
                box.innerHTML = `
                <img src="${media.src}" alt="${media.alt}">
            `;
            }

            if (media.type === 'VID') {
                box.innerHTML = `
                <iframe
                    src="https://www.youtube.com/embed/${media.ytid}?autoplay=1&playsinline=1&rel=0&controls=1&modestbranding=1&enablejsapi=1"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen>
                </iframe>
            `;
            }

            btnPrev.style.display = medias.length > 1 ? '' : 'none';
            btnNext.style.display = medias.length > 1 ? '' : 'none';
        };

        const open = (item) => {
            refreshMedias();

            const items = Array.from(container.querySelectorAll('._open_gallery'));
            currentIndex = items.indexOf(item);

            if (currentIndex < 0) currentIndex = 0;

            render();
            modalEl.classList.add('_show');
            modalEl.setAttribute('aria-hidden', 'false');
        };

        const close = () => {
            box.innerHTML = '';
            modalEl.classList.remove('_show');
            modalEl.setAttribute('aria-hidden', 'true');
        };

        const prev = () => {
            currentIndex = (currentIndex - 1 + medias.length) % medias.length;
            render();
        };

        const next = () => {
            currentIndex = (currentIndex + 1) % medias.length;
            render();
        };

        container.addEventListener('click', (e) => {
            const item = e.target.closest('._open_gallery');
            if (!item || !container.contains(item)) return;

            e.preventDefault();
            e.stopPropagation();

            open(item);
        }, {capture: true});

        btnClose?.addEventListener('click', close);
        btnPrev?.addEventListener('click', prev);
        btnNext?.addEventListener('click', next);

        modalEl.addEventListener('click', (e) => {
            if (e.target === modalEl) close();
        });

        document.addEventListener('keydown', (e) => {
            if (!modalEl.classList.contains('_show')) return;

            if (e.key === 'Escape') close();
            if (e.key === 'ArrowLeft') prev();
            if (e.key === 'ArrowRight') next();
        });

        swiper.on('slideChangeTransitionStart', close);
    },
    setupMediaImages(swiper) {

        const container = swiper.el;

        // On réutilise la même modale que pour les vidéos
        const modalEl = document.querySelector('.__modal_video');
        //if (!modalEl) return;

        const box = modalEl.querySelector('.__video_container');
        //if (!box) return;

        // Délégation de clic (même logique, capture pour passer avant Swiper)
        container.addEventListener('click', (e) => {
            const wrapper = e.target.closest('._open_img');
            if (!wrapper || !container.contains(wrapper)) return;

            const img = wrapper.querySelector('img');
            if (!img) return;

            const full =
                wrapper.dataset.full ||
                img.dataset.full ||
                img.currentSrc ||
                img.src;

            const alt = img.alt || '';

            box.innerHTML = `
            <img src="${full}"
                 alt="${alt}"
                 style="max-width:90vw;max-height:70vh;object-fit:contain;display:block;margin:0 auto;" />
        `;

            modalEl.classList.add('_show');
        }, {capture: true});
    },
    setupMediaVideos(swiper) {
        const container = swiper.el;

        // éléments de la modale "maison"
        const modalEl = document.querySelector('.__modal_video');
        const box = modalEl.querySelector('.__video_container');

        // fermeture → stoppe la vidéo
        const close = () => {
            box.innerHTML = '';
            modalEl.classList.remove('_show');
        };
        modalEl.addEventListener('click', (e) => {
            if (e.target === modalEl) close();
        });
        const btnClose = modalEl.querySelector('.__close_modal');
        if (btnClose) btnClose.addEventListener('click', close);

        // Délégation de clic (capture = true pour contourner preventClicks de Swiper)
        container.addEventListener('click', (e) => {
            const vid = e.target.closest('.__vid');
            if (!vid || !container.contains(vid)) return;

            const id = vid.dataset.ytid;
            if (!id) return;

            // injecte l'iframe avec autoplay
            box.innerHTML = `
              <iframe
                src="https://www.youtube.com/embed/${id}?autoplay=1&playsinline=1&rel=0&controls=1&modestbranding=1"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                loading="lazy"
              ></iframe>
            `;

            modalEl.classList.add('_show');
        }, {capture: true}); // <<— clé : capture pour que l’event passe avant Swiper
    }

};

export default fiches;
